import type { SupWeb3Balance, Networkish } from "@/types";
import type { Abi, Address } from "viem";
import { useMemo } from "react";

import useDeployment from "@/hooks/api/useDeployment";
import { getWeb3Address } from "@/utils";

/**
 * Fetch  superform's smart-contracts with the meta-data
 *
 * @param {SupWeb3Balance | Networkish | undefined} chainSelector
 * @return {{address: Address, abi: Abi, superpositions: Address} | undefined}
 */
export default function useChainContractConfig(chainSelector: SupWeb3Balance | Networkish | undefined):
  | {
      address: Address;
      abi: Abi;
      superpositions: Address;
      vaultClaimer: Address;
    }
  | undefined {
  const { data: ContractsData } = useDeployment();

  return useMemo(() => {
    if (!ContractsData || !chainSelector) {
      return undefined;
    }

    const targetChainId = typeof chainSelector === "object" ? chainSelector.chainId : chainSelector;
    const foundConfig = ContractsData.find(networkConfig => networkConfig.ChainID === targetChainId);

    return !foundConfig
      ? undefined
      : {
          address: getWeb3Address(foundConfig.SuperformRouter),
          superpositions: getWeb3Address(foundConfig.SuperPositions),
          vaultClaimer: getWeb3Address(foundConfig.VaultClaimer),
          abi: foundConfig.RouterAbi,
        };
  }, [chainSelector, ContractsData]);
}
